var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBracket = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 83,
  height: 351,
  fill: "none",
  viewBox: "0 0 83 351"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 175.684C0 105.89 35.627 39.648 73.833 0h8.383C41.646 51.944 23.59 110.65 23.59 175.684c0 65.035 18.431 123.722 58.626 175.288h-8.383C36.021 311.703 0 244.685 0 175.684Z"
})));
export default SvgBracket;